import React, { Component } from 'react';
import ProjectCard from './ProjectCard/ProjectCard';
import DetailsPane from './DetailsPane'
import moment from 'moment'
import axios from 'axios';
import './Projects.css';
import { APIURL } from '../../config'
import { withStyles } from '@mui/styles';
import Tooltip from "@mui/material/Tooltip";
import { TextField, InputAdornment, IconButton, Button, Autocomplete, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Redirect, withRouter } from 'react-router-dom';

const styles = {
    projList1: {
        height: 'calc(100vh - 249px)',
        width: "100%",
        overflowY: 'auto',
        scrollbarGutter: 'stable',
    },
    projList2: {
        height: 'calc(100vh - 545px)',
        width: "100%",
        overflowY: 'auto',
        scrollbarGutter: 'stable',
    }
};

class Projects extends Component {
    state = {
        showProjectDetails: false,
        projects: [],
        searchTerm: '',
        projectSearchResults: [],
        dropDowns: null,
        inputValue: '',
        isLoading: true,
        current_project: null,
        project_type: 'new', // new, old, initial
        ongoing_project: [],
        showMap: false,
        isSupport: this.props.user?.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') ? true : false,
        tabName: this.props.companySettings.length > 1 && this.props.companySettings.filter(setting => [101, 102].includes(setting.feature_id)).length > 0 ? 'Plans' :this.props.companySettings.length > 1 && this.props.companySettings.filter(setting => [104].includes(setting.feature_id)).length > 0 ? 'Cases' : 'Projects',
        redirectToNew: false,
        // AdminLevelProjects users can switch between their own projects and every company project, and open on All
        projectScope: this.props.user?.permissions?.AdminLevelProjects ? 'all' : 'associated',
        loadedScope: null,
        refreshing: false,
        customerLabel: this.props.user?.comp_settings.filter(setting => [101, 102, 104].includes(setting.feature_id)).length > 0 ? 'Client'
            : this.props.user?.comp_settings.filter(setting => setting.feature_id === 105).length > 0 ? 'Member' : 'Customer',
    }

    fetchSeq = 0;
    navSeq = 0;
    handledLocationKey = null;

    setAuthHeaders = () => {
        axios.defaults.headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            "Access-Control-Allow-Headers": 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
            "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
            "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
            Authorization: 'Bearer ' + window.localStorage.getItem('Fw4_access_Token')
        }
    }

    // Admins on "All" get every company project; everyone else gets the projects they're associated with
    getScopeParams = (scope) => {
        const loadAll = !!this.props.user.permissions.AdminLevelProjects && scope === 'all';
        return {
            company_id: this.props.comp_id,
            ...(this.props.selectedProgramId ? { program_id: this.props.selectedProgramId } : {}),
            ...(loadAll ? {} : { emp_id: this.props.user.emp_id, type: (this.props.user.permissions.ManagerLevelProjects) ? 'Manager' : 'Fieldworker' })
        };
    }

    // Only support-coordination companies have an "Initial" status option; everyone else
    // sees initial projects under Ongoing
    getStatusParam = (status) => status === 'new' && !this.state.isSupport ? 'new,initial' : status;
    getListStatus = (status) => status === 'initial' && !this.state.isSupport ? 'new' : status;

    loadProjects = async () => {
        const seq = ++this.fetchSeq;
        const isAdmin = !!this.props.user.permissions.AdminLevelProjects;
        const scope = isAdmin ? this.state.projectScope : 'associated';
        this.setState({ refreshing: true });
        this.props.checkTokenExpiry()
        this.setAuthHeaders();

        try {
            // The backend filters by the selected status, so only that status's projects are loaded
            const pData = await axios.get(APIURL + "/project/v1", { params: { ...this.getScopeParams(scope), status: this.getStatusParam(this.state.project_type) } });
            // A newer request (e.g. the admin toggled scope again) has replaced this one
            if (seq !== this.fetchSeq) return;
            const projList = Array.isArray(pData.data) ? pData.data : [];

            this.setState({
                projects: projList,
                projectSearchResults: projList,
                ongoing_project: projList,
                isLoading: false,
                loadedScope: scope,
                refreshing: false,
            }, this.sortByTitle);
        } catch (err) {
            console.error(err);
            if (seq === this.fetchSeq) this.setState({ refreshing: false });
        }
    }

    async componentDidMount() {
        // A link to a project loads that project's status list instead of the default one
        if (this.props.location?.projectsProps?.pro_id) {
            this.applyNavigation();
        } else {
            await this.loadProjects();
        }
    }

    // Runs once per navigation. A plain visit to /projects (including clicking it in the
    // sidebar while already here) shows the list; a link with projectsProps opens that project.
    applyNavigation = async () => {
        const location = this.props.location;
        if (!location || this.handledLocationKey === location.key) return;
        this.handledLocationKey = location.key;

        const navProps = location.projectsProps;
        if (!navProps || !navProps.pro_id) {
            this.setState({ current_project: null, inputValue: '' });
            return;
        }

        const navSeq = ++this.navSeq;
        const isAdmin = !!this.props.user.permissions.AdminLevelProjects;
        this.setState({ navLoading: true });
        this.props.checkTokenExpiry()
        this.setAuthHeaders();
        const fetchLinkedProject = async (scope) => {
            const pData = await axios.get(APIURL + "/project/v1", { params: { ...this.getScopeParams(scope), pro_id: navProps.pro_id } });
            return Array.isArray(pData.data) ? pData.data[0] : undefined;
        };
        // If the link can't be opened, fall back to the list (loading it if nothing has loaded yet)
        const showListInstead = () => this.setState({ navLoading: false, current_project: null }, () => {
            if (this.state.isLoading) this.loadProjects();
        });

        try {
            let scope = isAdmin ? this.state.projectScope : 'associated';
            let proj = await fetchLinkedProject(scope);
            // Admins only load their own projects on "My"; widen to all so the linked one can open
            if (!proj && isAdmin && scope !== 'all') {
                scope = 'all';
                proj = await fetchLinkedProject(scope);
            }
            if (navSeq !== this.navSeq) return;
            if (!proj) {
                showListInstead();
                return;
            }

            // Open the project straight away, then load the list for its status behind it
            this.setState({
                navLoading: false,
                isLoading: false,
                projectScope: scope,
                project_type: this.getListStatus(this.getProjectType(proj)),
                projects: [proj],
                projectSearchResults: [proj],
                ongoing_project: [proj],
                current_project: proj.pro_id,
                openTab: navProps.tab != null ? navProps.tab : undefined,
            }, this.loadProjects);
        } catch (err) {
            console.error(err);
            if (navSeq === this.navSeq) showListInstead();
        }
    }

    componentDidUpdate(prevProps) {
        this.applyNavigation();

        if (prevProps.selectedProgramId !== this.props.selectedProgramId) {
            this.setState({ isLoading: true }, async () => {
                await this.loadProjects();
            });
        }
    }

    getProjectType = (proj) => {
        if (!proj) return 'new';
        const start = proj.pro_starts_on;
        const end = (proj.pro_ends_on || '').replace(/Z/g, '');
        if (moment(start).isSameOrBefore('1900-01-01') && moment(end).isSame('1900-01-02', 'day')) return 'renewal';
        if (!start || !proj.pro_ends_on || moment(start).isSameOrBefore('1900-01-01')) return 'initial';
        if (!moment(proj.pro_ends_on).isBefore(moment())) return 'new';
        return 'old';
    }

    showProjectDetails = (key) => {
        this.setState({
            current_project: key,
            openTab: undefined,
        })
    }

    onBackClicked = () => {
        this.setState({
            showProjectDetails: false,
            current_project: null,
            inputValue: ''
        })
    }

    handleScopeChange = (event, value) => {
        if (value) this.setState({ projectScope: value }, this.loadProjects);
    }

    showProjectList = () => {
        if (this.state.ongoing_project) {
            return this.state.projectSearchResults.map(
                projects => <ProjectCard
                    {...this.props}
                    key={projects.pro_id}
                    id={projects.pro_id}
                    title={projects.pro_title}
                    start={projects.pro_starts_on || ''}
                    end={projects.pro_ends_on}
                    customerName={projects.customer_details[0].cus_name}
                    location={projects.locations ? projects.locations[0] : {}}
                    onClick={this.showProjectDetails}
                    onBack={this.onBackClicked}
                    selected={this.state.current_project === projects.pro_id ? 'active' : 'inactive'}
                />
            )
        } else {
            return <div>Loading....</div>
        }
    }

    generateMapsData = () => {
        let mapsData = this.state.projects.length !== 0 ? this.state.projects.map((pushPinData) => {
            if (!!pushPinData.locations) {
                return {
                    "location": [+pushPinData.locations[0].loc_lat || 0, +pushPinData.locations[0].loc_lon || 0],
                    "addHandler": "mouseover",
                    "infoboxOption": { title: pushPinData.customer_details[0].cus_name, description: pushPinData.locations[0].loc_addr_line1 + ',' + pushPinData.locations[0].loc_addr_line2 + "," + pushPinData.locations[0].loc_city + "," + pushPinData.locations[0].loc_state + "," + pushPinData.locations[0].loc_zip },
                    "pushPinOption": { color: 'red', title: pushPinData.pro_title }
                }
            } else { return null }

        }).filter((mp) => !!mp) : []
        return mapsData
    }

    searchProjHandler = (e) => {
        console.log(e.target.value);
        var searchQuery = e.target.value
        e.preventDefault()
        var searchTerm = new RegExp(searchQuery, 'i')
        console.log(searchTerm);
        let projectSearchResults = this.state.ongoing_project.map((proj) => {
            if (searchTerm.exec(proj.pro_title) || searchTerm.exec(proj.customer_details[0].cus_name)) {
                return proj
            }
            else {
                return null
            }
        }).filter((proj) => !!proj)

        this.setState({ projectSearchResults: projectSearchResults,  searchTerm: searchQuery },
            this.sortByTitle
        );
    }

    searchProjResults = (e) => {
        e.preventDefault()
        var searchTerm = new RegExp(this.state.searchTerm, 'i')
        console.log(searchTerm)
        let projectSearchResults = this.state.ongoing_project.map((proj) => {
            if (searchTerm.exec(proj.pro_title) || searchTerm.exec(proj.customer_details[0].cus_name)) {
                return proj
            }
            else {
                return null
            }
        }).filter((proj) => !!proj)

        this.setState({ projectSearchResults: projectSearchResults },
            this.sortByTitle
        )
    }

    // The backend filters by status (see getAProject in FWAPI), so changing it reloads the list
    filterProjects = (screen) => {
        if (screen === this.state.project_type) return;
        this.setState({ searchTerm: '', project_type: screen, current_project: null, inputValue: '' }, this.loadProjects);
    }

    // The list loads in title order; the grid's column headers handle any other sorting
    sortByTitle = () => {
        const { projects, projectSearchResults } = this.state;
        const sortedProjects = [...projects];
        const sortedSearchResults = [...projectSearchResults];
        sortedProjects.sort((a, b) => ('' + a.pro_title).localeCompare(b.pro_title));
        sortedSearchResults.sort((a, b) => ('' + a.pro_title).localeCompare(b.pro_title));
        this.setState({ projects: sortedProjects, projectSearchResults: sortedSearchResults });
    }

    toggleMap = () => {
        this.setState(prev => ({ showMap: !this.state.showMap }));
    };

    render() {
        const { classes } = this.props;
        const statusOptions = [
            { value: 'new',     label: `Ongoing ${this.state.tabName}` },
            { value: 'old',     label: `Completed ${this.state.tabName}` },
            ...(this.state.isSupport ? [{ value: 'initial', label: `Initial ${this.state.tabName}` }] : []),
            { value: 'renewal', label: `Late Renewal ${this.state.tabName}` }
        ];

        const isAdmin = !!this.props.user.permissions.AdminLevelProjects;
        const selectedProject = this.state.projects.find(p => p.pro_id === this.state.current_project);
        // A link from another page whose project hasn't been opened yet
        const pendingNavigation = !!this.state.navLoading;

        // Initial and late-renewal projects use 1900 placeholder dates; show those as blank
        const formatDate = (value) => value && moment.utc(value).year() > 1900 ? moment.utc(value).format('MM/DD/YYYY') : '';

        const projectColumns = [
            {
                field: 'pro_title', headerName: 'Title', flex: 1.5, minWidth: 180,
                // Styled like a link so it's clear the row opens the project
                renderCell: (params) => <span className="project-title-link">{params.value}</span>
            },
            {
                field: 'customer_name', headerName: this.state.customerLabel, flex: 1, minWidth: 150,
                valueGetter: (value, row) => row.customer_details?.[0]?.cus_name || ''
            },
            { field: 'pro_starts_on', headerName: 'Start', width: 110, valueFormatter: (value) => formatDate(value) },
            { field: 'pro_ends_on', headerName: 'End', width: 110, valueFormatter: (value) => formatDate(value) },
            {
                field: 'address', headerName: 'Address', flex: 2, minWidth: 220,
                valueGetter: (value, row) => {
                    const loc = row.locations?.[0];
                    return loc ? [loc.loc_addr_line1, loc.loc_addr_line2, loc.loc_city, loc.loc_state, loc.loc_zip].map(part => String(part || '').trim()).filter(Boolean).join(', ') : '';
                }
            },
            {
                field: 'employee_names', headerName: 'Employees', flex: 1.5, minWidth: 180,
                valueGetter: (value, row) => (row.employees || []).map(emp => `${emp.emp_first_name} ${emp.emp_last_name}`).join(', ')
            },
            {
                field: 'open', headerName: '', width: 50, sortable: false, filterable: false,
                disableColumnMenu: true, disableExport: true, hideable: false, align: 'center',
                renderCell: () => <ChevronRightIcon color="action" />
            },
        ];

        // The page renders straight away; the grid's loading overlay covers the first load
        const listLoading = this.state.isLoading || this.state.refreshing;
        const dashBoard = (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
                    {/* top nav */}
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '10px', gap: '20px' }}>
                        {selectedProject && (
                            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={this.onBackClicked}>
                                {this.state.tabName}
                            </Button>
                        )}
                        <Autocomplete
                            freeSolo
                            clearOnBlur={false}
                            inputValue={this.state.inputValue}
                            onInputChange={(e, newInput) => {
                                // Only update if newInput is not null/undefined
                                if (newInput !== null && newInput !== undefined) {
                                    this.setState({ inputValue: newInput });
                                }
                            }}
                            disableClearable
                            options={this.state.projectSearchResults}
                            getOptionLabel={p => p.pro_title || ''}
                            onChange={(e, val) => {
                                // Only update when a valid option is selected
                                if (val && typeof val === 'object' && val.pro_id) {
                                    this.setState({
                                        current_project: val.pro_id,
                                        inputValue: val.pro_title
                                    });
                                }
                                // If val is null/undefined or just a string, don't update
                            }}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    label="Project"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}
                            style={{ flex: '0 0 300px' }}
                            renderOption={(props, item) => (
                                <li {...props} key={item.key}>
                                    {item.pro_title}
                                </li>
                            )}
                        />
                        {/* Status and My/All only filter the list, so they're hidden on the details view */}
                        {!selectedProject && (
                            <Autocomplete
                                options={statusOptions}
                                getOptionLabel={opt => opt.label}
                                value={statusOptions.find(o => o.value === this.state.project_type) || null}
                                onChange={(e, val) => val && this.filterProjects(val.value)}
                                renderInput={params =>
                                    <TextField {...params} label="Status" variant="outlined" size="small" />}
                                style={{ flex: '0 0 250px' }}
                            />
                        )}
                        {!selectedProject && isAdmin && (
                            <ToggleButtonGroup
                                size="small"
                                exclusive
                                color="primary"
                                value={this.state.projectScope}
                                onChange={this.handleScopeChange}
                                aria-label={`Which ${this.state.tabName} to show`}
                            >
                                <ToggleButton value="associated">My {this.state.tabName}</ToggleButton>
                                <ToggleButton value="all">All {this.state.tabName}</ToggleButton>
                            </ToggleButtonGroup>
                        )}
                    </div>
                    {/* scrollable content area */}
                    <div style={{ display: 'flex', height: 'calc(100vh - 150px)' }}>
                        {selectedProject ? (
                            <DetailsPane
                                status={this.state.project_type === 'new' ? 'Ongoing'
                                     : this.state.project_type === 'old' ? 'Older' : 'Initial'}
                                comp_id={this.props.comp_id}
                                user={this.props.user}
                                history={this.props.history}
                                openTab={this.state.openTab}
                                project_details={selectedProject}
                                updateProject={async () => {
                                    // Re-fetch only the open project and swap it in place. It stays in the list even if
                                    // the edit moved it to another status, so the details don't close under the user.
                                    const proId = this.state.current_project;
                                    const pData = await axios.get(APIURL + "/project/v1", { params: { company_id: this.props.comp_id, pro_id: proId } });
                                    const updated = Array.isArray(pData.data) ? pData.data[0] : undefined;
                                    if (!updated) return;
                                    const replace = (list) => list.map(p => p.pro_id === proId ? updated : p);
                                    this.setState(prev => ({
                                        projects: replace(prev.projects),
                                        projectSearchResults: replace(prev.projectSearchResults),
                                        ongoing_project: replace(prev.ongoing_project),
                                    }));
                                }}
                                companySettings={this.props.companySettings}
                                checkTokenExpiry={this.props.checkTokenExpiry}
                            />
                        ) : pendingNavigation ? (
                            <div className="d-flex flex-row justify-content-center" style={{ width: '100%' }}>
                                <div style={{ color: '#3FA7D6', height: '5rem', width: '5rem', marginTop: 80 }}
                                     className="spinner-border text-info" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : listLoading || this.state.projectSearchResults.length !== 0 ? (
                            <div style={{ height: '100%', width: '100%', padding: '0 10px 10px' }}>
                                <DataGridPro
                                    rows={this.state.projectSearchResults}
                                    columns={projectColumns}
                                    getRowId={(row) => row.pro_id}
                                    loading={listLoading}
                                    onRowClick={(params) => this.showProjectDetails(params.id)}
                                    onCellKeyDown={(params, event) => {
                                        if (event.key === 'Enter') this.showProjectDetails(params.id);
                                    }}
                                    disableRowSelectionOnClick
                                    showToolbar
                                    density="compact"
                                    sx={{
                                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                                        '& .MuiDataGrid-row:hover': { backgroundColor: 'rgba(63, 167, 214, 0.08)' },
                                        '& .project-title-link': { color: 'primary.main', fontWeight: 600 },
                                        '& .MuiDataGrid-row:hover .project-title-link': { textDecoration: 'underline' },
                                    }}
                                />
                            </div>
                        ) : (
                            <div style={{ padding: 20 }}>
                                {isAdmin && this.state.projectScope === 'associated'
                                    ? `No ${this.state.tabName} are associated with you. Switch to All ${this.state.tabName} to see everyone's.`
                                    : `No ${this.state.tabName} found.`}
                            </div>
                        )}
                    </div>
                </div>
        )

        return (
            <div style={{ height: 'calc(100vh - 90px)', width: '100%', overflow: 'hidden' }}>
                {dashBoard}
            </div>
        )
    }
}

export default withStyles(styles)(withRouter(Projects));
